import Swiper from 'swiper/bundle';

jQuery(document).ready(function () {
   initRollrasenTabs();
   initScrollTop();
   initMobileMenu();
   initCrossSellSwiper();
   productFaq();
   handleKontaktformularScroll();
});


function initMobileMenu() {
   $('#menu-toggle, .menu-overlay').on('click', function () {
      $('#menu-toggle').toggleClass('is-active');
      $('.mobile-menu-container').toggleClass('is-active');
      $('.menu-overlay').toggleClass('is-active');
   });
}


function initRollrasenTabs() {
   function switchTab(targetTab) {
      $('#content-verlegeanleitung, #content-pflegetipps').hide().removeClass('active');
      $('#tab-btn-verleg, #tab-btn-pflege, #hero-btn-verleg, #hero-btn-pflege').removeClass('active');
      $('#meta-text-verleg, #meta-text-pflege').hide();

      if (targetTab === 'verlegeanleitung') {
         $('#content-verlegeanleitung').show().addClass('active');
         $('#tab-btn-verleg, #hero-btn-verleg').addClass('active');
         $('#meta-text-verleg').show();
         $('#footer-support-link').show();
      } else if (targetTab === 'pflegetipps') {
         $('#content-pflegetipps').show().addClass('active');
         $('#tab-btn-pflege, #hero-btn-pflege').addClass('active');
         $('#meta-text-pflege').show();
         $('#footer-support-link').hide();
      }
   }

   function togglePflegeAccordion(headerEl) {
      const $item = $(headerEl).closest('.pflege-accordion-item');
      const $body = $item.find('.pflege-body');
      const isOpen = $item.hasClass('active');

      // Close all other accordions and reset their arrows
      $('.pflege-accordion-item').not($item).removeClass('active').each(function () {
         $(this).find('.pflege-body').slideUp(200);
         $(this).find('.accordion-toggle-btn svg').html('<path d="M6 9l6 6 6-6"/>');
      });

      // Toggle current accordion
      if (isOpen) {
         $item.removeClass('active');
         $body.slideUp(200);
         $item.find('.accordion-toggle-btn svg').html('<path d="M6 9l6 6 6-6"/>');
      } else {
         $item.addClass('active');
         $body.slideDown(200);
         $item.find('.accordion-toggle-btn svg').html('<path d="M6 15l6-6 6 6"/>');
      }
   }

   switchTab('verlegeanleitung');

   $(document).on('click', '#hero-btn-verleg, #tab-btn-verleg', function (event) {
      event.preventDefault();
      switchTab('verlegeanleitung');
   });

   $(document).on('click', '#hero-btn-pflege, #tab-btn-pflege', function (event) {
      event.preventDefault();
      switchTab('pflegetipps');
   });

   $(document).on('click', '.btn-back-to-verlegung', function (event) {
      event.preventDefault();
      switchTab('verlegeanleitung');
   });


   $(document).on('click', '.btn-subtle-link', function (event) {
      event.preventDefault();
      switchTab('pflegetipps');

      $('html, body').animate({
         scrollTop: 0
      }, 100);
   });
   $(document).on('click', '.btn-back-to-verlegung', function (event) {
      event.preventDefault();
      switchTab('verlegeanleitung');
      $('html, body').animate({
         scrollTop: 0
      }, 100);
   });


   $(document).on('click', '#content-pflegetipps .pflege-header', function (event) {
      togglePflegeAccordion(this);
   });
}

function initCrossSellSwiper() {
   if (typeof Swiper !== 'undefined' && $('.cross-sell-swiper').length) {
      new Swiper('.cross-sell-swiper', {
         slidesPerView: 1,
         spaceBetween: 30,
         loop: true,
         speed: 800,
         grabCursor: true,
         centeredSlides: false,
         effect: 'slide',
         pagination: {
            el: '.swiper-pagination',
            clickable: true,
         },
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
         },
         breakpoints: {
            768: {
               slidesPerView: 2,
            },
            1024: {
               slidesPerView: 3,
            }
         }
      });
   }
}


function initScrollTop() {
   $(window).scroll(function () {
      if ($(this).scrollTop() > 800) {
         $('.scroll-to-top').addClass('active');
      } else {
         $('.scroll-to-top').removeClass('active');
      }
   });

   $('.scroll-to-top').click(function () {
      $('html, body').animate({scrollTop: 0}, 100);
      return false;
   });
}

function productFaq() {
   $('.product-faq-section .faq-trigger').on('click', function () {
      var $item = $(this).closest('.faq-item');
      var $content = $item.find('.faq-content');

      $item.toggleClass('is-open');

      if ($item.hasClass('is-open')) {
         $content.css('max-height', $content[0].scrollHeight + 'px');
      } else {
         $content.css('max-height', '0px');
      }
   });
}

jQuery(document).ready(function ($) {
   $('.single-product .product-summary .quantity').each(function () {
      var $quantityBox = $(this);
      var $input = $quantityBox.find('input.qty');

      // Prevent adding buttons twice if already present
      if ($quantityBox.find('.qty-btn').length > 0) {
         return;
      }

      // Insert minus button before input
      $('<button type="button" class="qty-btn qty-minus">-</button>').insertBefore($input);

      // Insert plus button after input
      $('<button type="button" class="qty-btn qty-plus">+</button>').insertAfter($input);

      // Minus click event
      $quantityBox.on('click', '.qty-minus', function (e) {
         e.preventDefault();
         var currentVal = parseFloat($input.val());
         var min = parseFloat($input.attr('min')) || 1;
         var step = parseFloat($input.attr('step')) || 1;

         if (!isNaN(currentVal) && currentVal > min) {
            $input.val(currentVal - step).trigger('change');
         }
      });

      // Plus click event
      $quantityBox.on('click', '.qty-plus', function (e) {
         e.preventDefault();
         var currentVal = parseFloat($input.val());
         var max = parseFloat($input.attr('max'));
         var step = parseFloat($input.attr('step')) || 1;

         if (isNaN(currentVal)) {
            currentVal = 0;
         }

         if (isNaN(max) || currentVal < max) {
            $input.val(currentVal + step).trigger('change');
         }
      });
   });
});

function handleKontaktformularScroll() {
   if (window.location.hash !== '#kontaktformular') {
      return;
   }

   setTimeout(function () {
      var $target = jQuery('#kontaktformular');

      if (!$target.length) {
         return;
      }

      var headerHeight = 100;

      jQuery('html, body').animate({
         scrollTop: $target.offset().top - headerHeight
      }, 400);
   }, 100);
}
